module.exports = __webpack_public_path__ + "static/media/night_icon_white.1953004c.svg";